import { render, staticRenderFns } from "./viewLastDays.vue?vue&type=template&id=2475f7e9&"
import script from "./viewLastDays.vue?vue&type=script&lang=js&"
export * from "./viewLastDays.vue?vue&type=script&lang=js&"
import style0 from "./viewLastDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports